import { render, staticRenderFns } from "./BiModalNewPolicyCoverDate.vue?vue&type=template&id=1e28cd97&"
import script from "./BiModalNewPolicyCoverDate.vue?vue&type=script&lang=ts&"
export * from "./BiModalNewPolicyCoverDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports